import React, { useEffect, useState } from "react";
import "./UserDetails.css";
import "./header/Header.css";
import Account from "./header/Account";

function UserDetails({
  userData,
  setUserData,
  isSignedIn,
  setIsSignedIn,
  isShowDetails,
  setIsShowDetails,
}) {
  const [favoriteTrips, setFavoriteTrips] = useState([]);

  useEffect(() => {
    fetch("https://ferry-backend.vercel.app/api/userData", {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        token: window.localStorage.getItem("token"),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setUserData(data.data);
      });
  }, []);

  const handleLogout = () => {
    window.localStorage.clear();
    setIsSignedIn(false);
  };

  const handleDetailsBtnClick = (e) => {
    setIsShowDetails(true);
  };

  return (
    <div className="loggedInNavbar">
      <button className="loginicon" onClick={(e) => handleDetailsBtnClick(e)}>
        My Account
      </button>
      <button className="loginicon" onClick={(e) => handleLogout(e)}>
        Log out
      </button>
      {isShowDetails && (
        <Account
          isSignedIn={isSignedIn}
          isShowDetails={isShowDetails}
          setIsShowDetails={setIsShowDetails}
          userData={userData}
          favoriteTrips={favoriteTrips}
        />
      )}
    </div>
  );
}

export default UserDetails;
